// 导出状态
export let exportStates = [
  {
    label: '导出中',
    value: 'CREATED'
  },
  {
    label: '已导出',
    value: 'STORED'
  },
  {
    label: '导出失败',
    value: 'FAILED'
  }
]

// 常用用户筛选条件
export let screenUser = [
  {
    label: '全部用户',
    value: 'ALL'
  },
  {
    label: '全部男性用户',
    value: 'MALE'
  },
  {
    label: '全部女性用户',
    value: 'FEMALE'
  },
  {
    label: '全部CPS绑定用户',
    value: 'bindCps'
  },
  {
    label: '全部非CPS绑定用户',
    value: 'bindCpsFalse'
  },
  {
    label: '全部非业务员',
    value: 'enableSalesMan'
  }
  // {
  //   label: '全部医护人员',
  //   value: 'DOCTOR_USER'
  // }
]
export let screenUserCheck = [
  {
    label: '批量筛选用户',
    value: 'beatch'
  },
  {
    label: '选择用户',
    value: 'select'
  },
  {
    label: '批量导入用户',
    value: 'import'
  }
]
export let invalidReasonsArr = [
  {
    label: '未在生命银行系统中注册',
    value: 'NO_REGISTRY'
  },
  {
    label: '手机号重复',
    value: 'MOBILE_REPEATED'
  },
  {
    label: '手机号在之前的导入中已存在',
    value: 'ALREADY_EXISTS'
  }
]
export let posterType = [
  {
    label: '商品海报',
    value: 'GOODS'
  },
  {
    label: '邀新海报',
    value: 'INVITATION'
  }
]
export let posterStatus = [
  {
    label: '草稿',
    value: 'SCRIPT'
  },
  {
    label: '已提交审核',
    value: 'SUBMITTED'
  },
  {
    label: '已发布', // 审核通过自动发布
    value: 'APPROVED'
  },
  {
    label: '已驳回',
    value: 'DECLINED'
  }
]
// 用户等级枚举、['青铜', '白银', '黄金', '铂金', '钻石']
export let levelType = [
  {
    label: '青铜',
    value: '0'
  },
  {
    label: '白银',
    value: '1'
  },
  {
    label: '黄金', // 审核通过自动发布
    value: '2'
  },
  {
    label: '铂金',
    value: '3'
  },
  {
    label: '钻石',
    value: '4'
  }
]
export let pointLimitType = [
  {
    label: '无',
    value: 'NO_LIMIT'
  },
  {
    label: '单日上限',
    value: 'SINGLE_DAY_LIMIT'
  },
  {
    label: '累计上限',
    value: 'TOTAL_LIMIT'
  },
  {
    label: '月度上限',
    value: 'MONTH_LIMIT'
  }
]
export let videoStatus = [
  {
    label: '草稿',
    value: 'SCRIPT'
  },
  {
    label: '待审核',
    value: 'SUBMITTED'
  },
  {
    label: '已发布',
    value: 'RELEASE'
  },
  {
    label: '已下架',
    value: 'OFF_SHELF'
  }
]
export let LiveStatus = [
  {
    label: '未开始',
    value: 'NOT_STARTED'
  },
  {
    label: '直播中',
    value: 'IN_PROGRESS'
  },
  {
    label: '已结束',
    value: 'FINISHED'
  }
]
// 支付渠道驱动
export let paymentDrivers = {
  'MOCK': 'MOCK',
  'WECHAT': '微信支付',
  'ALIPAY': '支付宝支付',
  'CMB': '招商银行聚合支付'
}
// 二维码业务类型
export let qrCodeBusinessTypes = [
  {
    label: '脐带血',
    value: 'CORD_BLOOD'
  },
  {
    label: '外周血',
    value: 'PERIPHERAL_BLOOD'
  }
]
// 新的静态码收款业务类型
export let qrCodeBusinessTypesOfStorage = [
  {
    label: '血带胎',
    value: 'BLOOD_CARRYING_FETUS'
  },
  {
    label: '外周血',
    value: 'PERIPHERAL_BLOOD'
  },
  {
    label: '其他',
    value: 'OTHER'
  }
]
